import { FC, ReactNode } from 'react'

import {
  Text,
  GreyGrey60,
  GreyGrey70,
  GreyGrey80,
  Primary13Regular,
  Primary13SemiBold,
  Tooltip,
  Box,
  Flex
} from '@sequencehq/core-components'
import { ErrorBoundary } from 'common/components/ErrorBoundary/ErrorBoundary'
import { formatTimestamp } from 'Automations/helpers'
import { inflect } from 'inflection'

export const UserAction: FC<{
  icon?: ReactNode
  label: ReactNode
  performedBy?: string | Array<string>
  timestamp?: string
}> = ({ icon, label, performedBy, timestamp }) => {
  const primaryUser = Array.isArray(performedBy) ? performedBy[0] : performedBy
  const otherUsers = Array.isArray(performedBy) ? performedBy.slice(1) : []

  return (
    <Flex gap="12px">
      {icon && (
        <Flex flexShrink="0" width="16px" height="16px" color={GreyGrey70}>
          {icon}
        </Flex>
      )}

      <Flex flexWrap="wrap">
        <Text {...Primary13Regular} color={GreyGrey70} marginRight="8px">
          {/* The label is emphasised as a semibold, darker heading to match the
              "Agents" timeline design. */}
          <Text as="span" {...Primary13SemiBold} color={GreyGrey80}>
            {label}
          </Text>
          {primaryUser ? ' by ' : ''}
          {primaryUser && (
            <Text
              as="span"
              {...Primary13SemiBold}
              color={GreyGrey70}
              wordBreak="break-all"
            >
              {primaryUser || 'Unknown User'}
            </Text>
          )}
          {otherUsers.length > 0 && (
            <>
              {' or '}
              <Tooltip
                label={
                  <Box>
                    {otherUsers.map(user => (
                      <Box key={user}>{user || 'Unknown User'}</Box>
                    ))}
                  </Box>
                }
              >
                <Text
                  as="span"
                  {...Primary13SemiBold}
                  color={GreyGrey70}
                  wordBreak="break-all"
                >
                  {otherUsers.length} {inflect('other', otherUsers.length)}
                </Text>
              </Tooltip>
            </>
          )}
          {!!timestamp && (
            <ErrorBoundary name="UserAction">
              <Text
                marginLeft="4px"
                as="span"
                {...Primary13Regular}
                color={GreyGrey60}
                whiteSpace="nowrap"
              >
                {formatTimestamp(timestamp)}
              </Text>
            </ErrorBoundary>
          )}
        </Text>
      </Flex>
    </Flex>
  )
}
